module.exports = __webpack_public_path__ + "img/icon_close_active.25d7d768.png";